// app/components/form-sections/TemplatePicker.jsx
"use client";
import Field from "../ui/Field";

export default function TemplatePicker({ TEMPLATE_CATALOG, selectedTemplates, setSelectedTemplates }) {
  return (
    <div className="mt-6">
      <span className="text-[13px] font-semibold text-slate-900">Templates (select one or more)</span>
      <div className="mt-2 grid sm:grid-cols-2 gap-2">
        {TEMPLATE_CATALOG.map((t) => {
          const checked = selectedTemplates.includes(t.id);
          return (
            <label
              key={t.id}
              className={[
                "flex items-start gap-3 rounded-xl border p-3 cursor-pointer transition",
                checked ? "border-teal-600 bg-gray-100" : "border-gray-200 bg-white hover:bg-slate-100",
              ].join(" ")}
              onClick={() =>
                setSelectedTemplates((prev) =>
                  prev.includes(t.id) ? prev.filter((x) => x !== t.id) : [...prev, t.id]
                )
              }
            >
              <input type="checkbox" className="mt-1 accent-teal-600" checked={checked} onChange={() => {}} aria-label={t.label} />
              <div>
                <div className="text-sm font-semibold text-slate-900">{t.label}</div>
                <div className="text-xs text-gray-500">{t.description}</div>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
